import { ArticlesListingActions, ArticlesListingStore } from './types';

export const defaultState: ArticlesListingStore = {
  error: null,
  isLoading: false,
  isLoaded: false,
  magazineArticleError: null,
  magazineArticleisLoading: false,
  magazineArticleisLoaded: false,
  articles: [],
  article: null,
  articlesCount: 0,
  articleCategories: [],
  pagination: 0,
  filter: null,
  dynamic_content: [],
};

const reducer = (
  state: ArticlesListingStore = defaultState,
  action: { type: ArticlesListingActions; payload?: any }
): ArticlesListingStore => {
  const {
    FetchListingBegin,
    FetchListingError,
    FetchListingSuccess,
    SetCategoryFilter,
    FetchCategoriesSuccess,
    FetchMagazineArticleBegin,
    FetchMagazineArticleSuccess,
    FetchMagazineArticleError,
  } = ArticlesListingActions;
  switch (action.type) {
    case FetchMagazineArticleBegin:
      return {
        ...state,
        magazineArticleisLoading: true,
        magazineArticleisLoaded: false,
        magazineArticleError: null,
      };
    case FetchMagazineArticleError: {
      return {
        ...state,
        magazineArticleisLoading: false,
        magazineArticleisLoaded: true,
        magazineArticleError: action.payload,
      };
    }
    case FetchMagazineArticleSuccess: {
      return {
        ...state,
        ...action.payload,
        magazineArticleisLoading: false,
        magazineArticleisLoaded: true,
        magazineArticleError: null,
      };
    }
    case FetchListingBegin: {
      return {
        ...state,
        isLoading: true,
        isLoaded: false,
        error: null,
      };
    }
    case FetchListingError: {
      return {
        ...state,
        isLoading: false,
        isLoaded: true,
        error: action.payload,
      };
    }
    case FetchListingSuccess: {
      const { pagination, articles, ...payload } = action.payload;
      return {
        ...state,
        //Pass all data returned by the backend (articles, subcategories, etc)
        ...payload,
        //If pagination is true ("See more" action), concatenate articles. Otherwise replace all of them (e.g. when filtering)
        articles: pagination ? [...state.articles, ...articles] : [...articles],
        // articleCategory: articleCategories && articleCategories.length ? articleCategories[0] : {},
        isLoading: false,
        isLoaded: true,
        error: null,
      };
    }
    case FetchCategoriesSuccess: {
      return {
        ...state,
        ...action.payload,
      };
    }
    case SetCategoryFilter: {
      return {
        ...state,
        filter: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};
export default reducer;
